import React from 'react'
import PulseLoader from 'react-spinners/PulseLoader'
// import { ThemeColor } from "../themecolor";

const Loader = () => {
  return <PulseLoader size={12} color={'#000000'} style={{ margin: '5px' }} />
}
export default Loader
